export default "__VITE_ASSET__D6Lu8NKs__"